// we don't have any of the commented languages in the catalog currently.
// if we add these languages we can uncomment them, but at the time of this
// writing we're planning to switch from language filters to a more unicode
// centric script filter.

export enum FontLanguage {
    // 'English' = 0,
    'Western European' = 1,
    'Central European' = 2,
    'Northern European' = 3,
    'Cyrillic' = 4,
    'Turkish' = 5,
    'Greek' = 6,
    'Hebrew' = 7,
    'Arabic' = 8,
    'Vietnamese' = 9,
    'Thai' = 10,
    // 'Japanese' = 11,
    // 'Simplified Chinese' = 12,
    // 'Traditional Chinese' = 13,
    // 'Korean' = 14,
}

export function isFontLanguage(value: unknown): value is FontLanguage {
    return typeof value === 'number' && value in FontLanguage;
}

export const FONT_LANGUAGES =
    Object.values(FontLanguage).filter(isFontLanguage);

export const FONT_LANGUAGE_OPTIONS = FONT_LANGUAGES.map((value) => ({
    value,
    label: FontLanguage[value],
}));
